import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { FaAlignLeft, FaAlignCenter, FaAlignRight } from 'react-icons/fa';

export default function InlineImageControls() {
    const [image, setImage] = useState(null);
    const [rect, setRect] = useState(null);
    const drag = useRef(null);
    const notify = element => element?.closest('[data-inline-editor], [id^="page_content_"]')?.dispatchEvent(new Event('input', { bubbles: true }));
    useEffect(() => {
        const pick = event => {
            if (event.target.closest('.diagramacao-image-controls, .diagramacao-floating-toolbar, .jodit-popup, .jodit-dialog')) return;
            const target = event.target.closest('img');
            setImage(target?.closest('#pdf_diagramado_2 [data-inline-editor], #pdf_diagramado_2 [id^="page_content_"]') ? target : null);
        };
        document.addEventListener('pointerdown', pick, true);
        return () => document.removeEventListener('pointerdown', pick, true);
    }, []);
    useEffect(() => {
        if (!image) { setRect(null); return undefined; }
        const update = () => {
            if (!image.isConnected) { setImage(null); return; }
            const box = image.getBoundingClientRect();
            setRect({ left: box.left, top: box.top, right: box.right, bottom: box.bottom });
        };
        const observer = new ResizeObserver(update);
        observer.observe(image);
        window.addEventListener('scroll', update, true); window.addEventListener('resize', update);
        update();
        return () => { observer.disconnect(); window.removeEventListener('scroll', update, true); window.removeEventListener('resize', update); };
    }, [image]);
    useEffect(() => {
        const move = event => {
            const active = drag.current;
            if (!active || !active.image.isConnected) return;
            const dx = event.clientX - active.startX;
            const dy = (event.clientY - active.startY) * active.width / active.height;
            const delta = Math.abs(dx) >= Math.abs(dy) ? dx : dy;
            const width = Math.min(active.maxWidth, active.maxHeight * active.width / active.height, Math.max(20, active.width + delta / active.scale));
            const height = Math.max(20, width * active.height / active.width);
            Object.assign(active.image.style, { width: `${width}px`, height: `${height}px`, maxHeight: 'none', maxWidth: '100%' });
            const box = active.image.getBoundingClientRect();
            setRect({ left: box.left, top: box.top, right: box.right, bottom: box.bottom });
        };
        const finish = () => {
            if (!drag.current) return;
            notify(drag.current.image); drag.current = null;
        };
        window.addEventListener('pointermove', move); window.addEventListener('pointerup', finish); window.addEventListener('pointercancel', finish);
        return () => { window.removeEventListener('pointermove', move); window.removeEventListener('pointerup', finish); window.removeEventListener('pointercancel', finish); };
    }, []);
    if (!image || !rect) return null;
    const align = position => {
        Object.assign(image.style, { display: 'block', float: 'none', marginLeft: position === 'left' ? '0px' : 'auto', marginRight: position === 'right' ? '0px' : 'auto' });
        const box = image.getBoundingClientRect();
        setRect({ left: box.left, top: box.top, right: box.right, bottom: box.bottom });
        notify(image);
    };
    return createPortal(<div className="diagramacao-image-controls hidethis">
        <div className="diagramacao-image-outline" style={{ left: rect.left, top: rect.top, width: rect.right - rect.left, height: rect.bottom - rect.top }} />
        <button type="button" className="diagramacao-image-corner" aria-label="Redimensionar imagem" title="Arraste para redimensionar a imagem" style={{ left: rect.right - 7, top: rect.bottom - 7 }} onPointerDown={event => {
            event.preventDefault(); event.stopPropagation();
            const box = image.getBoundingClientRect();
            const page = image.closest('[id^="page_content_"]');
            drag.current = { image, startX: event.clientX, startY: event.clientY, maxWidth: image.parentElement.clientWidth || Infinity, maxHeight: page ? Math.max(20, page.clientHeight - 24) : Infinity, width: image.offsetWidth || box.width, height: image.offsetHeight || box.height, scale: box.width / (image.offsetWidth || box.width) };
            event.currentTarget.setPointerCapture(event.pointerId);
        }} />
        <div className="diagramacao-image-align" style={{ left: Math.max(10, Math.min(rect.left, window.innerWidth - 260)), top: Math.max(90, rect.bottom + 12) }}>
            <span>Alinhar imagem</span><button type="button" aria-label="Alinhar imagem à esquerda" onClick={() => align('left')}><FaAlignLeft /></button><button type="button" aria-label="Centralizar imagem" onClick={() => align('center')}><FaAlignCenter /></button><button type="button" aria-label="Alinhar imagem à direita" onClick={() => align('right')}><FaAlignRight /></button>
        </div>
    </div>, document.body);
}
